<script lang="ts" setup>
import { computed, PropType } from "vue";
import { TirPmPlate } from "tir-components";
import { PaperClipIcon } from "tir-style-system/icons/outline";
import { TaskImportServiceEnum } from "@/enums";

const props = defineProps({
  /**Сервис импорта */
  importService: {
    type: String as PropType<TaskImportServiceEnum>,
    required: true,
  },
  /**Ссылка на задачу */
  taskUrl: { type: String },
});

const serviceName = computed(() => {
  switch (props.importService) {
    case TaskImportServiceEnum.Weeek:
      return "Weeek";
  }
});

const serviceNameTag = computed(() => (props.taskUrl ? "a" : "span"));
</script>

<template>
  <TirPmPlate class="task-import-files-alert" :is-show="true" is-rounded>
    <template #leftAddon>
      <PaperClipIcon class="task-import-files-alert__icon" />
    </template>
    <template #titleSlot> В импортированном тикете есть прикрепленные файлы </template>
    <template #subtitleSlot>
      <span>После создания тикета начнется загрузка файлов из тикета </span>
      <component
        v-if="serviceName"
        :is="serviceNameTag"
        :href="taskUrl"
        :target="taskUrl && '_blank'"
      >
        {{ serviceName }}
      </component>
    </template>
  </TirPmPlate>
</template>

<style lang="scss" scoped>
.task-import-files-alert {
  &__icon {
    width: 3rem;
    height: 3rem;
    color: var(--neutral-70, #686c73);
  }
}
</style>
